import { createCreditsChargeSdk } from '@patsnap/credits-charge'
import { ChromeBar } from '@pharmsnap/pharmsnap-web/components/browser/ChromeBar'
import { checkVersion } from '@pharmsnap/pharmsnap-web/utils/version/version-check'
import { useAuthStore, useLocale } from '@pharmsnap/shared/src/composition'
import { computed, defineAsyncComponent, defineComponent, onMounted, ref } from '@vue/composition-api'
import { getBrowserInfo } from 'pharmsnapMF_shared/utils'
import { CopilotDialogWithAuth } from './components/CopilotGpt/CopilotDialogWithAuth'
import { CopilotEntry } from './components/CopilotGpt/CopilotEntry'
import { InviteCopilotDialog } from './components/InviteCopilot/InviteCopilotDialog'
import { ServiceHelp } from './components/ServiceHelp/ServiceHelp'
import { SwitchTenantGuideDialogEntry } from './components/SwitchTenantGuideDialog/SwitchTenantGuideDialogEntry'
import { useCopilotChatStore } from './composable/useCopilotChatStore'
import { useLs360Provider } from './composable/useLs360ChatStore'
import { IS_CN_REGION, VUE_APP_DOMAIN_URL } from './config'
import { getAxios, getService } from './service/service'
import { E_ROUTER_NAME } from './types/enum'

export default defineComponent({
  components: {
    'selection-tool': defineAsyncComponent(() => import('./components/CopilotGpt/SelectionTool').then((r) => r.SelectionTool)),
  },
  name: 'APP',
  provide: {
    configProvider: {
      service: getService(),
    },
  },
  setup(_, { root }) {
    const {
      getters: { isSupportCopilot, isFreeUser },
    } = useAuthStore()
    const { locale } = useLocale()
    const creditsChargeSdk = IS_CN_REGION
      ? null
      : createCreditsChargeSdk({
          baseURL: VUE_APP_DOMAIN_URL,
          http: getAxios(),
          locale: locale.value,
        })
    useLs360Provider()
    // Copilot 组件会在部分路由被卸载，store 提前在根组件初始化，确保内部 route watcher 不随弹窗组件销毁。
    useCopilotChatStore()
    checkVersion()
    const browserInfo = getBrowserInfo()
    const ignoreChromeBar = ref(browserInfo.isModern)
    const handleIgnore = () => {
      ignoreChromeBar.value = true
    }
    onMounted(() => {
      try {
        creditsChargeSdk?.checkAndClaim()
      } catch {
        // ignore
      }
    })
    const isShowCopilot = computed(() => {
      if (!isSupportCopilot.value) {
        return false
      }
      const noCopilotRoute = [
        E_ROUTER_NAME.HOME,
        E_ROUTER_NAME.KNOWLEDGE_EXPLORE,
        E_ROUTER_NAME.KNOWLEDGE_GRAPH,
        E_ROUTER_NAME.EXPORT,
        E_ROUTER_NAME.COMPLETE_INFO,
        E_ROUTER_NAME.LS_CHAT_HOME,
        E_ROUTER_NAME.LS_CHAT,
        E_ROUTER_NAME.LS_CHAT_SHARE,
      ]
      return !noCopilotRoute.includes(root.$route.name as E_ROUTER_NAME)
    })

    return { isFreeUser, ignoreChromeBar, browserInfo, handleIgnore, isShowCopilot }
  },
  render() {
    return this.ignoreChromeBar ? (
      <div id="APP">
        <router-view class="h-screen" />
        <div class="absolute right-0 bottom-0 w-full pointer-events-none" style="top: 64px">
          {this.isShowCopilot && <CopilotDialogWithAuth />}
          {this.isShowCopilot && <CopilotEntry class="pointer-events-auto" />}
          <InviteCopilotDialog class="pointer-events-auto" />
        </div>
        <SwitchTenantGuideDialogEntry />
        {this.isShowCopilot ? <selection-tool></selection-tool> : null}
        {(IS_CN_REGION || this.isFreeUser) && <ServiceHelp />}
      </div>
    ) : (
      <div id="APP" class="flex flex-col h-screen">
        <ChromeBar onIgnore={this.handleIgnore} browserToLow={this.browserInfo.browserToLow} isSafari={this.browserInfo.isSafari} />
        <router-view class="flex-1" />
      </div>
    )
  },
})
